import React from "react"
import _ from "lodash"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import PhoneButton from "../Buttons/PhoneButton"
import PostBackButton from "../Buttons/PostBackButton"
import ShareButton from "../Buttons/ShareButton"
import UrlButton from "../Buttons/UrlButton"
import { isJSONString } from "../../util"
import "./Media.scss"

const HOTSWAP_ASSET_URL = isJSONString(process.env.REACT_APP_HOTSWAP_ASSET_URL) ? JSON.parse(process.env.REACT_APP_HOTSWAP_ASSET_URL) : false
const OLD_ASSET_URL = process.env.REACT_APP_OLD_ASSET_URL
const NEW_ASSET_URL = process.env.REACT_APP_NEW_ASSET_URL


function mediaContent(data) {
  if (data.url) {
    let processedUrl = data.url || _.get(data, "attachments[0].url")
    if (HOTSWAP_ASSET_URL && processedUrl) {
      if (processedUrl.startsWith(OLD_ASSET_URL)) {
        processedUrl = processedUrl.replace(OLD_ASSET_URL, NEW_ASSET_URL)
      }
    }
    switch (data.media_type) {
      case "video":
        return (
          <video src={processedUrl} controls>
          </video>
        )
      case "image":
        return (
          <img src={processedUrl} alt="" />
        )
      default:
        return (
          <div>MEDIA URL: <a href={processedUrl} target="_blank" rel="noopener noreferrer">{processedUrl}</a></div>
        )
    }
  } else if (data.attachment_id) {
    return (
      <div className="placeholder">
        <FontAwesomeIcon
          className="icon"
          icon="image"
        />
        <span>Media Attachment ID: {data.attachment_id}</span>
      </div>
    )
  } else {
    return (
      <div className="placeholder">
        <FontAwesomeIcon
          className="icon"
          icon="image"
        />
        <span>Media cannot be loaded</span>
      </div>
    )
  }
}

const Media = ({ data }) => {
  const { buttons } = data
  return (
    <div className="media-template">
      <div className="media">
        {mediaContent(data)}
      </div>
      {_.get(buttons, "length", 0) > 0 ?
        <div className="buttons-container">
          {buttons.map((button, i) => {
            switch (button.type) {
              case "web_url":
                return (
                  <UrlButton
                    key={i}
                    data={button}
                  />
                )
              case "postback":
                return (
                  <PostBackButton
                    key={i}
                    data={button}
                  />
                )
              case "phone_number":
                return (
                  <PhoneButton
                    key={i}
                    data={button}
                  />
                )
              case "element_share":
                return (
                  <ShareButton
                    key={i}
                    data={button}
                  />
                )
              default:
                return (
                  <PostBackButton
                    key={i}
                    data={button}
                  />
                )
            }
          })}
        </div>
        :
        null
      }
    </div>
  )
}

export default Media
